import React from 'react';
import PropTypes from 'prop-types';
import { formatters } from 'common';
import { FormattedMessage } from 'react-intl';
import styles from './styles.css';
import messages from './messages';
import DefListColumn from '../DefListColumn';
import DefSubListItem from '../DefSubList';
import MailingAddressDetails from '../ MailingAddressDetails';

const TransferPanelCheckDetails = ({
  ctsId,
  payer,
  payerAddress,
  beneficiary,
  beneficiaryAddress,
  deliveryMethod,
  memo,
  showAllFields,
  checkBeneficiaryMailingAddress,
  showMailingAddressModal,
  showMailingAddressModalState,
  hideMailingAddressModal,
  mailingAddressError,
}) => {
  const memos = memo ? [...memo].map((mem) => mem || '') : ['', '', ''];
  return (
    <div className={styles.rightPane}>
      {showAllFields && (
        <DefListColumn
          className={styles.defList}
          title={<FormattedMessage {...messages.ctsId} />}
          data={ctsId}
          dataTestHandle="checkDetails__ctsId"
        />
      )}
      {payer && (
        <div className={styles.listContainer}>
          <div className={styles.listTitle}>
            <FormattedMessage {...messages.payer} />
          </div>
          <div className={styles.subList}>
            {payer.name && (
              <DefSubListItem
                title="Name"
                data={formatters.formatTitleCase(payer.name)}
                dataTestHandle="checkDetails__payerName"
              />
            )}
            {payerAddress && (
              <DefSubListItem title="Address" data={payerAddress} dataTestHandle="checkDetails__payerAddress" />
            )}
          </div>
        </div>
      )}
      {beneficiary && (
        <div className={styles.listContainer}>
          <div className={styles.listTitle}>
            <FormattedMessage {...messages.beneficiary} />
          </div>
          <div className={styles.subList}>
            {beneficiary.name && (
              <DefSubListItem
                title="Name"
                data={formatters.formatTitleCase(beneficiary.name)}
                dataTestHandle="checkDetails__beneficiaryName"
              />
            )}
            {beneficiaryAddress && (
              <React.Fragment>
                <DefSubListItem
                  title="Address"
                  data={beneficiaryAddress}
                  dataTestHandle="checkDetails__beneficiaryAddress"
                />
                <div
                  className={styles.mailingAddressLinkContainer}
                  dataTestHandle="checkDetails__viewMailingAddressLink"
                >
                  <button
                    className={styles.mailingAddressLink}
                    onClick={showMailingAddressModal}
                    onKeyDown={showMailingAddressModal}
                  >
                      View Mailing Address
                  </button>
                </div>
                <MailingAddressDetails
                  show={showMailingAddressModalState}
                  onHide={hideMailingAddressModal}
                  mailingAddress={checkBeneficiaryMailingAddress}
                  mailingAddressError={mailingAddressError}
                />
              </React.Fragment>
            )}
          </div>
        </div>
      )}
      <DefListColumn
        className={styles.defList}
        title={<FormattedMessage {...messages.deliveryMethod} />}
        data={deliveryMethod}
        dataTestHandle="checkDetails__deliveryMethod"
      />
      <div className={styles.listContainer}>
        <div className={styles.listTitle}>
          <FormattedMessage {...messages.memo} />
        </div>
        <div className={styles.subList}>
          <DefSubListItem title="Memo 1 (Invoice)" data={memos[0]} dataTestHandle="checkDetails__memo1" />
          <DefSubListItem title="Memo 2 (Invoice)" data={memos[1]} dataTestHandle="checkDetails__memo2" />
          <DefSubListItem title="Memo 3 (Check)" data={memos[2]} dataTestHandle="checkDetails__memo3" />
        </div>
      </div>
    </div>
  );
};

TransferPanelCheckDetails.propTypes = {
  ctsId: PropTypes.number.isRequired,
  payer: PropTypes.object,
  payerAddress: PropTypes.string,
  beneficiary: PropTypes.object,
  beneficiaryAddress: PropTypes.string,
  deliveryMethod: PropTypes.string.isRequired,
  memo: PropTypes.array,
  showAllFields: PropTypes.bool.isRequired,
  checkBeneficiaryMailingAddress: PropTypes.object,
  showMailingAddressModal: PropTypes.func.isRequired,
  hideMailingAddressModal: PropTypes.func.isRequired,
  showMailingAddressModalState: PropTypes.bool.isRequired,
  mailingAddressError: PropTypes.object,
};

TransferPanelCheckDetails.defaultProps = {
  payer: null,
  payerAddress: null,
  beneficiary: null,
  beneficiaryAddress: null,
  memo: [],
  checkBeneficiaryMailingAddress: null,
  mailingAddressError: null,
};

export default TransferPanelCheckDetails;



// WEBPACK FOOTER //
// ./src/components/transferPanelCheckDetails/index.js